import { render } from "./PageRiwayatPenanganan.vue?vue&type=template&id=40f802a4"
import script from "./PageRiwayatPenanganan.vue?vue&type=script&lang=js"
export * from "./PageRiwayatPenanganan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__